import SoftButton from "components/SoftButton";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import SoftBox from "components/SoftBox";
import { Grid, Switch } from "@mui/material";
import SoftTypography from "components/SoftTypography";
import { updateUserPreferences } from "api/UserApi";
import { useAuth0 } from "@auth0/auth0-react";
import { useDispatch } from "react-redux";
import { setUserPreferences } from "redux/actions/portal/usersActionCreator";

const allowedPreferences = [
  "WORKFLOW_CONNECTORS_COUNTS_STATUS",
  "WORKFLOW_CONNECTORS_SUCCESS_FAIL_RATE"
];

const changePreferenceName = (preference) =>
  preference
    .split("_")
    .map((preference) => preference[0].toUpperCase() + preference.slice(1).toLowerCase())
    .join(" ");

export default function UserPreferenceDialog({
  open,
  onClose,

  acceptButtonText,
  dialogTitle,
  acceptButtonColor,
  userPreferences
}) {
  const dispatch = useDispatch();
  const { user } = useAuth0();

  const handleAccept = async () => {
    await updateUserPreferences(user?.cxfUserId, user?.stripeId, userPreferences);

    onClose();
  };

  const preferencesToBeUsed = Object.keys(userPreferences ?? {}).filter((preference) =>
    allowedPreferences.includes(preference)
  );

  const handleUpdatePreference = (updatedPreferences) => {
    dispatch(setUserPreferences(updatedPreferences));
  };

  return (
    <>
      <Dialog
        fullWidth={true}
        maxWidth={"md"}
        open={open}
        onClose={onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{dialogTitle}</DialogTitle>
        <DialogContent>
          {preferencesToBeUsed.map((key) => {
            return (
              <SoftBox px={2} key={key}>
                <Grid container>
                  <Grid size={{ xs: 8 }}>
                    <SoftTypography variant="button" fontWeight="regular" color="text">
                      {changePreferenceName(key)}
                    </SoftTypography>
                  </Grid>

                  <Grid size={{ xs: 4 }}>
                    <SoftBox textAlign="end">
                      <Switch
                        checked={userPreferences[key] === "active" ? true : false}
                        onChange={(e) => {
                          handleUpdatePreference({
                            ...userPreferences,
                            [key]: e.target.checked === true ? "active" : "hidden"
                          });
                        }}
                      />
                    </SoftBox>
                  </Grid>
                </Grid>
              </SoftBox>
            );
          })}
        </DialogContent>
        <DialogActions>
          <SoftButton onClick={onClose} variant="outlined" color="info">
            Cancel
          </SoftButton>
          <SoftButton
            variant="contained"
            color={acceptButtonColor ? acceptButtonColor : "info"}
            onClick={handleAccept}
          >
            {acceptButtonText}
          </SoftButton>
        </DialogActions>
      </Dialog>
    </>
  );
}
